// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Wrapper_scroll-black__IYRMH","wrapper":"Wrapper_wrapper__RaaUG"};